module.exports = __webpack_public_path__ + "img/company_1.19816844.jpg";